// Handles milestone completion across the site, as needed. Give 'em a little
// encouragement when they're doing good. Should primarily use okevents.
// -----------------------------------------------------------------------------

import $ from "jquery";
import _strf from "shared/util/_strf";
import {
	OKEVENT,
	subscribeToOkEvent,
} from "shared/util/OkEventHelpers";

window.QuestionMilestones = {
	thresholds: [ 25, 50, 100 ],
	numAnswered: window.SESSION.num_qans || 0,

	/*
	 * Open a feedback banner with a congrats for having answered X questions.
	 *
	 * @param {Number} num - the number of questions the user has answered
	 */
	notify(num) {
		FeedbackBanner.open({
			type: "success",
			timeout: 3000,
			message: _strf(
				"Better matches unlocked! You’ve answered $num questions.",
				{ num },
			),
		});
	},

	/*
	 * Update the number of questions the user has answered, and call notify if
	 * appropriate.
	 *
	 * @param {Number} num - the number of questions the user has answered
	 */
	updateCount(num) {
		this.numAnswered = num;

		if (this.thresholds.indexOf(num) >= 0) {
			this.notify(num);
		}
	},
};

// if the questions page rewrite makes it out for desktop selfview, this okevent
// block can be deleted (at that point, it will all run through the singleton
// above). at that point, we could also take this out of the legacy/globals
// folder and import it in the questions duck.
subscribeToOkEvent(OKEVENT.QuestionAnswer, function(ev) {
	QuestionMilestones.numAnswered++;

	QuestionMilestones.thresholds.forEach((num) => {
		if (num === QuestionMilestones.numAnswered) {
			QuestionMilestones.notify(num);
		}
	});
});



// WEBPACK FOOTER //
// ./src/legacy/milestones.js